const handleEnterKey = (onKeyPress?: Function, goToNextInput: boolean = true) => {
  return (event: React.KeyboardEvent<HTMLInputElement>) => {
    const key = event?.key
    const value = (event?.target as HTMLInputElement)?.value?.trim()
    if (key === 'Enter') {
      if (goToNextInput) {
        const inputElements = Array.prototype.slice
          .call(document.querySelectorAll('input,textarea'))
          .filter(input => input.id)
        const index = inputElements.findIndex(field => field.id === event.target['id'])
        inputElements[index + 1] && inputElements[index + 1].focus()
      }
      if (onKeyPress) {
        onKeyPress(value)
      }
      event.preventDefault()
    }
  }
}

export default handleEnterKey
